export default __webpack_public_path__ + "static/media/bunny.45a3bd74.png";